import { render, staticRenderFns } from "./SNotifications.vue?vue&type=template&id=17b66130&scoped=true"
import script from "./SNotifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./SNotifications.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SNotifications.vue?vue&type=style&index=0&id=17b66130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b66130",
  null
  
)

export default component.exports